import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const IntegrationManagement = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Entegrasyon Yönetimi
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Entegrasyon yönetimi burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default IntegrationManagement;
